module.exports = {
  prefix: 'tw-',
  purge: process.env.NODE_ENV === "development"
    ? false
    : [
      './Resources/src/js/**/*.js',
      './Resources/views/**/*.html.twig',
      './Twig/Extension/**/*.php',
      './Document/Areabrick/**/*.php',
    ],
  safelist: process.env.NODE_ENV === "development" ? [{ pattern: /.*/ }] : [],
  darkMode: false, // or 'media' or 'class'
  theme: {
    fontFamily: {
      sans: [
        'Readex Pro',
        'ui-sans-serif',
        'system-ui',
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
      ],
      serif: ['ui-serif', 'Georgia', 'Cambria', 'Times', 'serif'],
    },
    screens: {
      xs: '380px',
      sm: '480px',
      md: '768px',
      lg: '1024px',
      xl: '1280px',
      xxl: '1440px',
      xxxl: '1680px',
      max: '1920px',
    },
    container: {
      center: true,
      padding: '2rem',
    },
    header: {
      height: {
        sm: '70px',
        lg: '80px',
      },
    },
    footer: {
      height: {
        sm: 'auto',
        lg: '81px',
      },
    },
    // override all colors from default config with following
    colors: {
      transparent: 'transparent',
      current: 'currentColor',
      white: '#ffffff',
      black: '#000000',
      brand: '#006DD1',
      gray: {
        300: '#E1E1E1',
        800: '#343334',
        900: '#222222',
      },
      red: {
        200: '#F92F60',
      },
      blue: '#006DD1',
    },
    fontSize: {
      xs: '.75rem',
      sm: '.875rem',
      tiny: '.875rem',
      base: ['1rem', '1.875'],
      lg: ['1.125rem', '1.875'],
      xl: '1.25rem',
      '2xl': ['1.875rem', '1.1428571429'],
      '3xl': ['2.1875rem', '1.1428571429'],
      '3-1/2xl': ['3.125rem', '1.1428571429'],
      '4xl': ['4.375rem', '1.1428571429'],
      '5xl': '3rem',
      '6xl': '4rem',
      '7xl': '5rem',
    },
    extend: {
      borderWidth: {
        3: '3px',
        14: '14px',
      },
      minHeight: {
        32: '512px',
      },
    },
  },
  variants: {},
  plugins: [],
};
